/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Work_Activity_Too_Many_FilesInputs */

const vi_error_work_activity_too_many_files = /** @type {(inputs: Error_Work_Activity_Too_Many_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi hoạt động chỉ đính kèm tối đa 10 tệp. Vui lòng gỡ bớt tệp rồi lưu lại.`)
};

/**

* @param {Error_Work_Activity_Too_Many_FilesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_work_activity_too_many_files = /** @type {((inputs?: Error_Work_Activity_Too_Many_FilesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Work_Activity_Too_Many_FilesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_work_activity_too_many_files(inputs)
});